import { render, staticRenderFns } from "./sharepoint-config.vue?vue&type=template&id=70e5c932"
import script from "./sharepoint-config.vue?vue&type=script&lang=js"
export * from "./sharepoint-config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports